$(()=>{

    App.Gallery = {

        prevSliderItemsSelector: '.js--gallery-prev-slider-item',

        init: function(){

            $('.js--gallery').each(function(){

                let $component = $(this),
                    $bigSlider = $('.js--gallery-big-slider', $component),
                    $prevArrow = $('.js--gallery-prev', $component),
                    $nextArrow = $('.js--gallery-next', $component),
                    $prevSlider = $('.js--gallery-prev-slider', $component);

                let bigSliderOption = {
                        lazyLoad: 'ondemand',
                        prevArrow: $prevArrow,
                        nextArrow: $nextArrow,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    adaptiveHeight: true,
                                    fade: true,
                                    swipe: false,
                                    infinite: false
                                }
                            }
                        ]
                    },
                    prevSliderOption = {
                        lazyLoad: 'ondemand',
                        arrows: false,
                        slidesToShow: 4,
                        swipe: false,
                        infinite: false
                    };

                if (!$component.hasClass('_init-gallery')) {

                    $component.addClass('_init-gallery');

                    $bigSlider.slick(bigSliderOption);

                    $prevSlider.slick(prevSliderOption);

                    function changePrevSlider(){

                        let activeIndex = $('.slick-current', $bigSlider).attr('data-slick-index');

                        $(App.Gallery.prevSliderItemsSelector, $component).removeClass('_active');

                        let $activeSlide = $('.slick-slide[data-slick-index='+activeIndex+']', $prevSlider),
                            $activeItem = $(App.Gallery.prevSliderItemsSelector, $activeSlide);
                        $activeItem.addClass('_active');

                        let $nextSlide = $activeSlide.next();
                        if ($nextSlide.attr('aria-hidden') == 'true') {
                            $prevSlider.slick('next');
                        }

                        let $prevSlide = $activeSlide.prev();
                        if ($prevSlide.attr('aria-hidden') == 'true') {
                            $prevSlider.slick('prev');
                        }

                    }

                    changePrevSlider();
                    $bigSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        setTimeout(()=>{
                            changePrevSlider();
                        }, 100);
                    }).on('change', function(event, slick, currentSlide, nextSlide){
                        setTimeout(()=>{
                            changePrevSlider();
                        }, 100);
                    });

                    $(document).on('click', App.Gallery.prevSliderItemsSelector, function(e){
                        e.preventDefault();

                        if ($component.is(e.target) || $component.has(e.target).length) {

                            let index = $(this).closest('.slick-slide').attr('data-slick-index');
                            $bigSlider.slick('slickGoTo', index);

                        }
                    });

                } else {

                    $bigSlider.slick('unslick').slick(bigSliderOption);
                    $prevSlider.slick('unslick').slick(prevSliderOption);

                }

            });

        }

    };
    App.Gallery.init();

});